import { useLocation } from "@reach/router";
import React from "react";

import { Text } from "@components/Text/Text.component";

import pageDates from "@data/schema/page-dates.json";

interface PageDatesEntry {
  datePublished: string;
  dateModified: string;
}

interface LastUpdatedProps {
  path?: string;
}

function normalizePath(pathname: string): string {
  if (pathname === "/") return "/";
  return pathname.endsWith("/") ? pathname : `${pathname}/`;
}

function formatDate(iso: string): string {
  return new Date(iso).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

export function LastUpdated({ path }: LastUpdatedProps) {
  const location = useLocation();
  const lookup = normalizePath(path ?? location.pathname);
  const entry = (pageDates as Record<string, PageDatesEntry | undefined>)[
    lookup
  ];

  if (!entry?.dateModified) return null;

  return (
    <Text
      size="xs"
      fs="italic"
      c="fontDarkSecondary"
      ta="center"
      mt="xl"
      mb="md"
      px="md"
    >
      Last updated: {formatDate(entry.dateModified)}
    </Text>
  );
}
